export const accountEsTranslation = {
  account: {
    plaidIdentityVerification: {
      title: "Se requiere verificación de identidad",
      description:
        "Para continuar con su solicitud de arrendamiento, necesitamos verificar su identidad. Este proceso es seguro y está gestionado por nuestro socio de confianza Plaid.",
      startButton: "Iniciar verificación de identidad",
      startingButton: "Iniciando verificación...",
      completeButton: "Verificación completa",
      successMessage: "Su identidad ha sido verificada exitosamente",
      failureMessage:
        "La verificación de identidad falló. Por favor, inténtelo de nuevo.",
      failure: {
        DOC_IMAGE_QUALITY:
          "La foto de tu identificación no es clara. Tómala con buena iluminación, mantén la cámara firme y evita los reflejos.",
        DOC_COMPOSITION:
          "No pudimos enmarcar correctamente la foto de tu identificación. Coloca el documento sobre una superficie oscura y captura el documento completo.",
        DOC_AUTHENTICITY:
          "No pudimos confirmar la autenticidad del documento. Intenta con otra identificación oficial.",
        DOC_UNSUPPORTED:
          "El documento que subiste no es válido. Usa un pasaporte, licencia de conducir, identificación estatal, tarjeta de residente permanente o visa temporal.",
        DOC_GENERIC:
          "No pudimos verificar tu identificación. Intenta de nuevo con una foto más clara.",
        SELFIE_LIVENESS:
          "Tu selfie no pasó la verificación de prueba de vida. Vuelve a tomarla mirando directo a la cámara con buena iluminación.",
        SELFIE_NO_MATCH:
          "Tu selfie no coincide con la foto de tu identificación. Vuelve a tomarla con tu rostro claramente visible.",
        SELFIE_GENERIC: "No pudimos verificar tu selfie. Intenta de nuevo.",
        KYC_DOB_MISMATCH:
          "La fecha de nacimiento que ingresaste no coincide con tu identificación. Por favor verifícala e intenta de nuevo.",
        KYC_NAME_MISMATCH:
          "El nombre que ingresaste no coincide con tu identificación. Usa tu nombre tal como aparece en tu identificación oficial.",
        KYC_ADDRESS_MISMATCH:
          "La dirección que proporcionaste no coincide con nuestros registros. Por favor verifícala y vuelve a ingresarla.",
        KYC_ID_MISMATCH:
          "No pudimos verificar el número de identificación. Por favor revisa lo que ingresaste.",
        KYC_PHONE_MISMATCH:
          "El número de teléfono que ingresaste no coincide con nuestros registros.",
        KYC_GENERIC:
          "Parte de la información que ingresaste no coincide con tu identificación. Revisa tu nombre, fecha de nacimiento y dirección.",
        RISK_DECLINED:
          "No pudimos completar tu verificación. Por favor contacta a soporte.",
        WATCHLIST_FLAGGED:
          "No pudimos completar tu verificación. Por favor contacta a soporte.",
        INCOMPLETE: "Tu verificación no se completó. Intenta de nuevo.",
        UNKNOWN: "La verificación de identidad falló. Intenta de nuevo.",
      },
      contactSupport: "¿Necesita ayuda? Contáctenos en",
      errorMessage:
        "No se pudo inicializar la verificación. Por favor, inténtelo de nuevo.",
      acceptedDocumentsTitle: "Documentos que puedes usar",
      acceptedDocuments: {
        passport: "Pasaporte",
        driversLicense: "Licencia de conducir",
        stateId: "Identificación estatal",
        residentCard: "Tarjeta de residente permanente",
        temporaryVisa: "Visa temporal",
      },
    },
    registerProspect: {
      provideInfoTitle:
        "Proporcione información adicional para completar el registro",
      createAccountTitle: "Crea una cuenta para registrarte",
      alreadyRegistered: "¿Ya registrado?",
      clickToLogin: "Haga clic aquí para iniciar sesión",
      firstNameLabel:
        "Nombre(s) (tal como aparece en su identificación oficial)",
      middleNameLabel: "Segundo nombre (si corresponde)",
      lastNameLabel:
        "Apellido(s) (tal como aparece en su identificación oficial)",
      phoneLabel: "Teléfono",
      emailLabel: "Correo electrónico",
      passwordLabel: "Contraseña",
      confirmPasswordLabel: "Confirmar contraseña",
      consentCommsLabel:
        "Doy mi consentimiento para recibir correos electrónicos y/o mensajes de texto relevantes en el correo electrónico y/o número de teléfono indicados anteriormente. Pueden aplicarse tarifas estándar de datos y mensajes.",
      privacyPolicyLabel: "He leído y acepto la ",
      privacyPolicyLink: "Política de privacidad",
      rentalCriteriaLabel: "He leído y acepto los ",
      rentalCriteriaLink: "Criterios de alquiler",
      createAccountButton: "Crear cuenta",
      continueButton: "Continuar",
      applicationNoticeTitle: "Aviso de solicitud",
      applicationNoticeDescription1:
        "Antes de continuar, tenga a mano una identificación con foto emitida por el gobierno. Esto puede incluir: <ul><li>Pasaporte (se aceptan pasaportes emitidos por EE. UU. y por otros países)</li><li>Licencia de conducir de EE. UU.</li><li>Identificación estatal de EE. UU.</li><li>Tarjeta de residente permanente</li><li>Visa temporal</li></ul>",
      applicationNoticeDescription2:
        "<strong>Tarifa de solicitud:</strong> Cada solicitante debe pagar una tarifa de solicitud no reembolsable para cubrir los costos de procesamiento administrativos y de terceros. El pago de la tarifa no garantiza la aprobación.",
      applicationNoticeDescription3:
        "<strong>Tarifa administrativa:</strong> Además de la tarifa de solicitud, el hogar debe pagar una tarifa administrativa. Esta tarifa no garantiza la aprobación, y el apartamento no se alquilará hasta que su solicitud esté completa y se reciban todos los documentos/fondos requeridos. Los documentos requeridos deben proporcionarse dentro de las 72 horas para evitar retrasos o posible denegación.",
      applicationNoticeDescription4:
        "<strong>Requisitos de ingresos:</strong> Los ingresos mensuales brutos combinados de todos los arrendatarios deben cumplir con el requisito mínimo de la propiedad y se verificarán antes de la aprobación. La verificación aceptable puede incluir talones de pago, extractos bancarios, documentación de beneficios/apoyo, cartas de oferta o activos calificativos. Los solicitantes autónomos y basados en propinas/comisiones pueden necesitar documentación adicional, y los estudiantes que no cumplan con el requisito pueden necesitar un cosignatario calificado.",
      registrationErrorHeading: "Error de Registro",
      errorMessage: "Hay un error. Por favor intente de nuevo.",
      inviteAuthMismatchTitle: "Cuenta incorrecta para esta invitación",
      inviteAuthMismatchBody:
        "Esta invitación es para <strong>{{email}}</strong>, pero has iniciado sesión con otra cuenta. Cierra la sesión y abre el enlace de invitación de nuevo para continuar como ese solicitante.",
      inviteAuthSignOutButton: "Cerrar sesión y continuar",
      // Validation errors
      required: "Por favor complete este campo",
      emailInvalid:
        "Por favor ingrese una dirección de correo electrónico válida",
      phoneInvalid: "El número de teléfono requiere 10 dígitos",
      nameMustIncludeBoth:
        "El nombre debe incluir tanto el nombre como el apellido",
      passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
      passwordUppercase:
        "La contraseña debe contener al menos una letra mayúscula",
      passwordLowercase:
        "La contraseña debe contener al menos una letra minúscula",
      passwordNumber: "La contraseña debe contener al menos un número",
      passwordsMustMatch: "Las contraseñas deben coincidir",
      noLeasingAgent: "Ninguno",
      languageLabel: "Idioma Preferido",
      prospectSourceLabel: "¿Cómo se enteró de nosotros?",
      referrerNameLabel:
        "Nombre y número de unidad del referente (si lo hay) (ej John Doe, Apt 4B)",
      leasingAgentLabel: "¿Está trabajando con un agente de arrendamiento?",
    },
    unitDetails: {
      title: "Detalles de la unidad",
      unitNumber: "Número de unidad",
      beds: "Habitación(es)",
      baths: "Baño(s)",
      term: "Plazo",
      months: "Meses",
      moveIn: "Fecha de mudanza",
      rent: "Alquiler base",
      deposit: "Depósito de seguridad",
      recurringCharges: "Cargos Mensual recurrentes",
      oneTimeCharges: "Cargos Únicos",
      perMonth: "por mes",
      latestMoveInPossibleFrom: "Última fecha de mudanza posible desde",
      rentUpdatedTo: "Alquiler actualizado a",
      from: "desde",
      basedOnMoveIn: "según la fecha de mudanza",
      feesDisclaimer:
        "Pueden aplicarse otras tarifas facturadas por nuestro proveedor de servicios públicos, las tarifas mencionadas anteriormente se facturan a través de nuestro sistema de administración de propiedades",
      studio: "Estudio",
    },
    leaseApplication: {
      stepTitle: "Paso",
      step: "Paso",
      of: "de",
      next: "Siguiente",
      previous: "Anterior",
      submit: "Enviar",
      // Common fields
      name: "Nombre",
      email: "Correo electrónico",
      phone: "Teléfono",
      address: "Dirección",
      country: "País",
      street: "Dirección",
      city: "Ciudad",
      state: "Estado",
      zip: "Código postal",
      // Step titles
      idVerification: "ID Verificación",
      applicantInfo: "Info del solicitante",
      currentAddress: "Dirección",
      employment: "Ingresos",
      petsVehicles: "Mascotas, Vehículos y Rentables",
      termsConditions: "T & C",
      review: "Revisar",
      members: "Miembros",
      // Applicant Info
      birthdate: "Fecha de nacimiento",
      identification: "Identificación",
      identificationNumber: "Número de identificación",
      identificationType: "Tipo",
      ssn: "Número de Seguro Social",
      ssnOptional: "Número de Seguro Social *",
      noSsn: "No tengo SSN",
      ssnFormat: "Formato: XXX-XX-XXXX",
      usCitizen: "Soy ciudadano estadounidense",
      emergencyContact: "Contacto de emergencia",
      emergencyContactName: "Nombre",
      relationship: "Relación",
      uploadFrontPicture: "Subir foto del frente",
      uploadBackPicture: "Subir foto del reverso",
      idVerificationProcess: "Proceso de verificación de identidad",
      // ID Types
      driversLicense: "Licencia de conducir",
      passport: "Pasaporte",
      idCard: "Tarjeta de identificación",
      residencyPermit: "Permiso de residencia",
      temporaryVisa: "Visa temporal",
      // Address
      currentAddressTitle: "Dirección actual",
      moveInDate: "Fecha de mudanza en la residencia actual",
      reasonForLeaving: "Motivo de salida",
      areYouRenting: "¿Es esta una dirección de alquiler?",
      landlordName: "Nombre de la comunidad o arrendador",
      contactName: "Nombre de contacto",
      landlordPhone: "Teléfono",
      // Employment
      employmentTitle: "Ingresos",
      employmentDescription:
        "📝 Utilizamos Proofup como nuestro socio de verificación de ingresos. Recibirá una opción para verificar sus ingresos a través de nuestro proceso de verificación seguro en el último paso de este proceso. Para ser elegible para alquilar en esta propiedad, necesita tener ingresos 2.5 veces el monto del alquiler.",
      employmentDescriptionWithGuarantor:
        "<br/>⚠️ No cumple con los requisitos de ingresos. Si usted y sus co-solicitantes no cumplen con los criterios de ingresos juntos y cree que puede cumplir con un garante, puede agregar uno a continuación.",
      notApplicable: "No aplicable",
      industry: "Industria",
      employer: "Empleador",
      title: "Título",
      startDate: "Inicio",
      endDate: "Fin",
      monthlyIncome: "Ingresos mensuales",
      supervisorName: "Nombre del supervisor",
      supervisorPhone: "Teléfono",
      currentlyEmployed: "Actualmente trabajo aquí",
      emailAddress: "Dirección de correo electrónico",
      otherIncomeSources: "Fuentes de ingresos adicionales",
      otherIncomeHelp:
        "Opcional. Agregue otros ingresos (pensión alimenticia, beneficios, regalos, etc.) que deban contar para la calificación.",
      addIncome: "Agregar ingreso",
      incomeType: "Tipo",
      effectiveDate: "Fecha efectiva",
      incomeFrequency: "Frecuencia de ingresos",
      incomeAmount: "Cantidad de ingresos",
      noIncome: "No tengo ingresos",
      noIncomeDescription:
        "Usted indicó que no tiene ingresos. Esta propiedad requiere un ingreso de al menos {{incomeLevel}} veces el alquiler mensual para calificar.",
      noIncomeDescription1:
        "Sus ingresos no cumplen con el requisito de {{incomeLevel}} veces el alquiler mensual. Esta propiedad requiere un ingreso de al menos {{incomeLevel}} veces el alquiler mensual para calificar.",
      noIncomeDescription2:
        "Esta propiedad requiere un ingreso de al menos {{incomeLevel}} veces el alquiler mensual para calificar.",
      useCoApplicantIncomeTitle: "¿Usar ingresos de co-solicitante?",
      useCoApplicantIncomeDescription:
        "Notamos que ha agregado miembros del hogar a su solicitud. ¿Le gustaría continuar con los ingresos de un co-solicitante para fortalecer su solicitud?",
      // Pets & Vehicles
      petsVehiclesTitle: "Algo más que le gustaría agregar?",
      pets: "Mascotas",
      addPets: "Agregar mascotas",
      addPetsMax: "Agregar mascotas (Máx. {{count}} por unidad)",
      maxPetsPerUnit: "Máximo 2 por unidad",
      petPolicyUnavailable:
        "Comuníquese con la oficina de arrendamiento para conocer la política de mascotas de esta unidad.",
      petName: "Nombre",
      petType: "Tipo",
      breed: "Raza",
      color: "Color",
      age: "Edad (años)",
      weight: "Peso (lbs.)",
      vehicles: "Vehículos",
      addVehicle: "Agregar vehículo",
      hasVehiclesQuestion: "¿Tiene algún vehículo para registrar?",
      year: "Año",
      make: "Marca",
      model: "Modelo",
      licensePlate: "Número de placa",
      licensePlateState: "Estado",
      // Members
      willAnyoneElseLive: "¿Vivirá alguien más aquí?",
      willAnyoneElseLiveHelp:
        "Incluya a todos los adultos y menores que vivirán en la unidad (sin incluirlo a usted).",
      notAnswered: "Sin respuesta",
      addMembers: "Agregar miembros",
      householdStatus: "Relación",
      spouse: "Cónyuge/Cohabitante",
      familyAdult: "Miembro de la familia - Adulto",
      familyMinor: "Miembro de la familia - Menor",
      roommate: "Compañero de cuarto",
      birthDate: "Fecha de nacimiento",
      addGuarantors: "Quiere agregar garantes para apoyar su solicitud?",
      addGuarantor: "Agregar garante",
      addGuarantorsQuestion:
        "Quiere agregar garantes para apoyar su solicitud?",
      addGuarantorsDescription:
        "¿Quiere agregar garantes para apoyar su solicitud?",
      guarantor: "Garante",
      anythingElseToAdd: "Algo más que le gustaría agregar?",
      // Terms & Review
      termsConditionsTitle: "Términos y condiciones",
      agreeToTerms: "Acepto los términos y condiciones",
      reviewTitle: "Revisar información",
      confirmInformation:
        "Confirmo que la información proporcionada es correcta según mi conocimiento",
      // Validation messages
      phoneValidation: "El teléfono debe tener 10 dígitos",
      agreeValidation: "Debe aceptar los términos y condiciones",
      dependentAgeValidation: "Los dependientes deben tener menos de 18 años",
      fullNameValidation: "Por favor ingrese nombre y apellido",
      // Pet types
      dog: "Perro",
      cat: "Gato",
      bird: "Pájaro",
      fish: "Pez",
      other: "Otro",
      // Array field template
      addPet: "Agregar mascota",
      addMember: "Agregar miembro",
      addRentableItem: "Agregar elemento rentable",
      addIncomeSource: "Agregar fuente de ingresos",
      addItem: "Agregar elemento",
      pet: "Mascota",
      vehicle: "Vehículo",
      member: "Miembro",
      rentableItem: "Elemento rentable",
      rentableItems: "Elementos rentables",
      incomeSource: "Fuente de ingresos",
      item: "Elemento",
      noPetsAdded: "Aún no se han agregado mascotas",
      noVehiclesAdded: "Aún no se han agregado vehículos",
      noMembersAdded: "Aún no se han agregado miembros del hogar",
      noGuarantorsAdded: "Aún no se han agregado garantes",
      noIncomeSourcesAdded:
        "Aún no se han agregado fuentes de ingresos adicionales",
      noItemsAdded: "Aún no se han agregado elementos",
      noRentableItemsAdded: "Aún no se han agregado elementos rentables",
      remove: "Eliminar",
      // Review labels
      number: "Número",
      type: "Tipo",
      yes: "Sí",
      no: "No",
      driversLicenseTitle: "Licencia de Conducir",
      landlord: "Arrendador",
      landlordContact: "Contacto del Arrendador",
      currentEmploymentTitle: "Empleo Actual",
      otherIncomeTitle: "Otros Ingresos",
      emergencyContactTitle: "Contacto de Emergencia",
      vehicleInformationTitle: "Información del Vehículo",
      householdMembersTitle: "Miembros del Hogar",
      miscellaneousTitle: "Varios",
      feeAndDepositTitle: "Tarifas y Depósito",
      supervisor: "Supervisor",
      supervisorEmail: "Correo del Supervisor",
      noPets: "Sin Mascotas",
      noVehicles: "Sin Vehículos",
      registration: "Registro",
      assistant: "Asistente",
      howDidYouHear: "Cómo se enteró de nosotros?",
      referringAgent: "Agente de Referencia",
      referringAgency: "Agencia de Referencia",
      otherComments: "Otros Comentarios",
      reasonForMoving: "Razón para Mudarse",
      feeReviewText:
        "Por favor revise las tarifas a continuación. Será redirigido a una página para completar su pago",
      applicationFee: "Tarifa de Solicitud",
      unitFee: "Tarifa de Administración",
      // Pet policy
      allowed: "Permitido",
      notAllowed: "No Permitido",
      fees: "Tarifas",
      rent: "Renta",
      // Validation errors
      required: "es una propiedad requerida",
      minLength: "NO debe ser más corto que",
      maxLength: "NO debe ser más largo que",
      minimum: "debe ser >=",
      maximum: "debe ser <=",
      pattern: "no coincide con el patrón requerido",
      petPattern: "No puede tener caracteres especiales",
      licensePlatePattern:
        "Ingrese una placa válida — solo letras y números, hasta 10 caracteres",
      format: "debe coincidir con el formato",
      enum: "debe ser igual a uno de los valores permitidos",
      invalidEmail: "debe ser una dirección de correo electrónico válida",
      invalidDate: "debe ser una fecha válida",
      invalidNumber: "debe ser un número válido",
    },
    incomeVerification: {
      title: "Verificación de Ingresos",
      requiredError:
        "La verificación de ingresos es obligatoria para continuar.",
      subtitle: "📊 Verifique sus Ingresos con Proofup",
      alreadyCompleted:
        "La verificación de ingresos ya ha sido completada. Puede proceder al siguiente paso.",
      partner:
        "Nos asociamos con Proofup para proporcionar un proceso de verificación de ingresos seguro y eficiente.",
      instruction:
        "Por favor verifique sus ingresos utilizando el proceso de verificación seguro a continuación.",
      description:
        "Para completar su solicitud de arrendamiento, ofrecemos la verificación de ingresos a través de nuestro socio de confianza Proofup. Este proceso seguro ayuda a agilizar su solicitud y puede acelerar la aprobación.",
      videoTitle: "Cómo funciona la verificación de ingresos",
      whatYouNeedTitle: "Lo que necesitará:",
      needItem1: "Acceso a su cuenta bancaria en línea o cuenta de nómina",
      needItem2:
        "Recibos de pago recientes o extractos bancarios (si es necesario)",
      needItem3: "Aproximadamente 5-10 minutos para completar el proceso",
      startButton: "Iniciar Verificación",
      openingButton: "Abriendo…",
      waitingButton: "Esperando finalización…",
      verifiedButton: "Verificación Completada",
      retryButton: "Reintentar Verificación",
      skipButton: "Omitir por ahora - Continuar al Pago",
      skipForNow: "Omitir por ahora",
      verifyIncomeCta: "Verificar Ingresos",
      postPaymentIntro:
        "Verifique sus ingresos para ayudar a agilizar la revisión de su solicitud. Puede hacerlo ahora o volver a esto en cualquier momento desde sus solicitudes.",
      securityNote:
        "Su información está segura y encriptada. Proofup sigue prácticas de seguridad estándar de la industria para proteger sus datos financieros.",
      invalidRequestTitle: "Solicitud Inválida",
      invalidRequestMessage:
        "No se proporcionó ID de arrendamiento. Por favor regrese a la solicitud.",
      goHomeButton: "Ir al Inicio",
      noAddressProvided: "No se proporcionó dirección",
    },
    leasePayment: {
      applicantInformation: "Información del Solicitante",
      applicantName: "Nombre del Solicitante",
      paymentSuccess: "Pago Exitoso",
      paymentSuccessMessage:
        "Su pago fue exitoso! Nos comunicaremos con usted en breve con cualquier actualización sobre el estado de su solicitud",
      balanceDue: "Saldo Adeudado",
      total: "Total",
      payment: "Pago",
      selectAmount: "Seleccionar monto",
      optionBalance: "Tarifa de solicitud y administración",
      optionTotalLeaseBalance: "Saldo total del arrendamiento",
      optionYourFee: "Su tarifa de solicitud y administración",
      optionHouseholdFees: "Tarifas de todos los adultos",
      optionCustomAmount: "Monto personalizado",
      customAmountPlaceholder: "Ingrese el monto personalizado",
      customAmountWarning:
        "Las solicitudes se procesarán después de que se paguen todas las tarifas requeridas y cualquier saldo pendiente se pague en su totalidad. (Use esta opción solo si lo indica un Consultor de Arrendamiento.)",
      payAmount: "Monto a pagar",
      amountLoading: "Cargando",
      cardTab: "Tarjeta",
      achTab: "ACH",
      noFeeDueHelp:
        "La tarifa de solicitud es $0.00 (exenta o no requerida). Haga clic a continuación para enviar sin pago.",
      completeApplication: "Completar solicitud",
      debitCard: "Tarjeta de Débito",
      creditCard: "Tarjeta de Crédito",
      cardHolderName: "Nombre del Titular de la Tarjeta",
      cardPaymentError: "Pago con Tarjeta",
      unitUnavailableHeading: "La unidad ya no está disponible",
      unitUnavailableBody:
        "La unidad que intentabas reservar ya no está disponible. Por favor elige otra unidad.",
      viewAvailableUnits: "Ver unidades disponibles",
      unit: "Unidad",
      monthlyRent: "Renta mensual",
      moveInTooSoon: {
        heading: "La fecha de mudanza debe ser más tarde",
        body: "Elija una fecha de mudanza posterior para continuar.",
        pickDate: "Elija una nueva fecha de mudanza",
        saveAndContinue: "Guardar fecha y continuar",
        saveError:
          "No pudimos actualizar su fecha de mudanza. Inténtelo de nuevo.",
        confirmRentHeading: "Confirmar renta actualizada",
        confirmRentBody:
          "Esta fecha de mudanza cambia su renta mensual. Confirme el nuevo monto para continuar.",
        leaseTerm: "Plazo del contrato",
        months: "{{term}} meses",
        previousRent: "Renta anterior",
        newRent: "Nueva renta mensual",
        confirmRent: "Confirmar renta y continuar",
        cancel: "Cancelar",
      },
      submitButton: "Enviar",
      validation: {
        required: "Por favor complete este campo",
        emailInvalid: "Por favor ingrese un correo electrónico válido",
        phoneNumberInvalid: "Se requiere un número de teléfono de 10 dígitos",
        accountNumberInvalid: "Se requiere una entrada entre 5 y 17 dígitos",
        accountsNotMatch: "Las cuentas no coinciden",
        routingNumberInvalid: "Se requiere una entrada de solo 9 dígitos",
        selectAccountType: "Por favor seleccione el tipo de cuenta",
        zipcodeInvalid: "Se requiere una entrada de solo 5 dígitos",
        selectCardType: "Por favor seleccione el tipo de tarjeta",
        namesRequired: "Por favor ingrese el apellido.",
        emptyCardNumber: "Por favor ingrese un número de tarjeta válido",
        invalidCardNumber: "El número de tarjeta es inválido",
        emptyExpiryDate: "Por favor ingrese una fecha de vencimiento válida",
        monthOutOfRange: "El mes de vencimiento debe estar entre 01 y 12",
        yearOutOfRange: "El año de vencimiento no puede estar en el pasado",
        dateOutOfRange: "La fecha de vencimiento no puede estar en el pasado",
        invalidExpiryDate: "La fecha de vencimiento es inválida",
        emptyCVC: "Por favor ingrese un código de seguridad válido",
        invalidCVC: "El código de seguridad es inválido",
      },
    },
  },
};
